import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

const CountryCodeDropdown = ({ countryCodes, countryCode, setCountryCode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filteredCodes = countryCodes.filter((c) =>
    c.country.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div ref={dropdownRef} className="relative w-44">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between bg-white border border-gray-300 rounded-lg px-3 py-3 focus:ring-2 focus:ring-green-400 transition-all"
      >
        <span className="flex items-center gap-2 text-black">
          {countryCodes.find((c) => c.code === countryCode)?.label}{" "}
          <span className="text-gray-500">{countryCode}</span>
        </span>
        <ChevronDown
          className={`w-5 h-5 text-gray-500 transition-transform ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
            className="absolute z-50 mt-2 w-full bg-white border border-gray-200 rounded-lg shadow-xl max-h-60 overflow-y-auto"
          >
            <div className="sticky top-0 bg-white px-3 py-2 border-b border-gray-100">
              <input
                type="text"
                placeholder="Search country..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-green-400"
              />
            </div>

            <ul className="max-h-56 overflow-y-auto text-sm">
              {filteredCodes.length > 0 ? (
                filteredCodes.map((c) => (
                  <li
                    key={c.code}
                    onClick={() => {
                      setCountryCode(c.code);
                      setIsOpen(false);
                      setSearch("");
                    }}
                    className="px-3 py-2 hover:bg-green-50 flex items-center gap-2 cursor-pointer transition"
                  >
                    <span>{c.label}</span>
                    <span className="text-gray-500">{c.code}</span>
                  </li>
                ))
              ) : (
                <li className="px-3 py-2 text-gray-400 text-center">
                  No results
                </li>
              )}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default CountryCodeDropdown;
